import React, { useState } from "react"

export default function QuestionBox({
  title: _title,
  children
}: {
  title?: string
  children: React.ReactNode
}) {
  const [visible, setVisible] = useState(false)

  return (
    <div
      className="relative inline-flex items-center ml-2"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <span className="inline-flex items-center justify-center font-bold text-blue-700 border-2 border-blue-700 rounded-full cursor-default w-5 h-5 text-sm leading-none">
        ?
      </span>

      {visible && (
        <div className="absolute z-10 text-left bg-blue-50 border border-blue-500 text-blue-900 text-sm rounded-md p-3 shadow-md w-96 top-7 left-1/2 -translate-x-1/2">
          {children}
        </div>
      )}
    </div>
  )
}
